import React from 'react'
import Snackbar from "@mui/material/Snackbar"
import SnackbarContent from "@mui/material/SnackbarContent"
import Typography from '@mui/material/Typography'
import { FileError } from 'react-dropzone'

type Props = {
  error: FileError | null
  onClose: () => void
}

const Toast: React.FC<Props> = ({ error, onClose }) => {
  if (!error) return null
  const { title, description } = formatMessage(error)

  return (
    <Snackbar
      open={!!error}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={5000}
      onClose={onClose}
      data-testid="snackbar"
    >
      <SnackbarContent
        message={
          <>
            <Typography variant='body2' fontWeight={700}>
              {title}
            </Typography>
            <Typography variant='caption'>{description}</Typography>
          </>
        }
      />

    </Snackbar>
  )
}

export default Toast

const formatMessage = (error: FileError) => {
  switch (error.code) {
    case 'file-too-large':
      return {
        title: 'Arquivo muito grande',
        description: error.message || 'O arquivo enviado é maior do que o limite permitido.'
      }
    case 'too-many-files':
      return {
        title: 'Muitos arquivos anexados',
        description: 'Você não pode enviar mais de 6 arquivos.'
      }
    case 'file-already-exists':
      return {
        title: 'Arquivo já anexado',
        description: error.message || 'Arquivo já foi anexado anteriormente.'
      }
    default:
      return {
        title: 'Tipo de arquivo não suportado',
        description: 'O tipo de arquivo enviado não é suportado.'
      }
  }
}
